export default __webpack_public_path__ + "static/media/upload_data-dark.2d75ec91.svg";